import type { TooltipProps } from '@movingimage-evp/mi-ui-component-library/types/components/tooltip/tooltip';

import { InfoCircleIcon, Tooltip, classNames } from '@movingimage-evp/mi-ui-component-library';

import styles from './info-tooltip.module.css';

export function InfoTooltip({ className, position, ...props }: TooltipProps) {
  return (
    <Tooltip delay={0} {...props}>
      <InfoCircleIcon className={classNames(styles.infoTooltip, className)} />
    </Tooltip>
  );
}
